module.exports = __webpack_public_path__ + "img/2023-gq1.86b7caf1.jpg";